const axios = require('axios');

async function sendEmail(to, subject, text) {
    const data = {
        // 阿里云邮件推送的请求体格式
        "from": "your-email@example.com", // 发件人邮箱
        "to": to, // 收件人邮箱
        "subject": subject, // 邮件主题
        "text": text, // 邮件正文
    };

    try {
        const response = await axios.post('https://dm.aliyuncs.com/sendMail', data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer YOUR_ACCESS_TOKEN' // 使用阿里云的访问令牌
            }
        });
        console.log(response.data);
    } catch (err) {
        console.error(err);
    }
}

module.exports = { sendEmail };